import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import React from 'react';
import { useTranslation } from '../../../hooks/useTranslation';
import { toSentenceCase } from '../../../util/format';
import colors from '../../../themes/main-colors';
import ROUTES from '../../../routes';
import {
  EnergyTrackerData,
  PgeEnergyTrackerData,
} from '../../../__generated__/pge-types';
import {
  BillComparisonWidgetNonRes,
  BillComparisonWidget,
} from '../../OpowerWidgets';
import DataBrowserWidget from '../../OpowerWidgets/components/EnergyUseDatabrowserWidget';
import { getEnergyTrackerData } from '../single-account/queries';

import ProjectedUsage from './projected-usage/ProjectedUsage';
import { CircularProgress } from '@material-ui/core';
import usePgeQuery from '../../../hooks/usePgeQuery';
import { useAccountCustomerDashboard } from '../../../hooks/useAccountCustomerDashboard';
import { useLocation } from '@reach/router';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    colorTextPrimary: {
      color: colors.noirBlur,
    },
    compare: {
      color: colors.noirBlur,
      marginLeft: '.5em',
    },
    arrow: {
      color: theme.palette.success.main,
    },
  }),
);

export interface EnergyUsageProps {
  pgeEnergyTrackerData: PgeEnergyTrackerData | undefined | null;
  encryptedAccountNumber: string | null | undefined;
  encryptedPersonId: string | null | undefined;
  showHeader?: boolean | null;
  currentPath?: string | null;
}

const EnergyUsage = ({
  pgeEnergyTrackerData,
  encryptedAccountNumber,
  encryptedPersonId,
  showHeader = true,
  currentPath,
}: EnergyUsageProps) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { showLegacyUI, isResAccount } = useAccountCustomerDashboard();
  // const { loading: loading, data: etData, error } = usePgeQuery<{
  //   getEnergyTrackerData: EnergyTrackerData;
  // }>(getEnergyTrackerData, {
  //   variables: {
  //     params: {
  //       encryptedAccountNumber: encryptedAccountNumber,
  //       encryptedPersonId: encryptedPersonId,
  //     },
  //   },
  //   errorPolicy: 'all',
  //   skip: !encryptedAccountNumber || !encryptedPersonId,
  // });

  // const projectedUsageData = etData?.getEnergyTrackerData;
  // const showProjectedUsage = projectedUsageData?.detailsAvailable;
  // const projectedUsageLoading = loading || !projectedUsageData;

  return (
    <Grid container direction="column" spacing={2}>
      {showLegacyUI && showHeader && (
        <Grid item>
          <Typography
            className={classes.colorTextPrimary}
            component={'span'}
            variant={'h2'}
          >
            {toSentenceCase(t('TRACK_YOUR_ENERGY_USE'))}
          </Typography>
        </Grid>
      )}
      {currentPath !== ROUTES.VIEW_BILL && (
        <Grid item xs={12} sm={12}>
          <Card>
            <CardHeader
              title={t('MY_USE')}
              titleTypographyProps={{
                variant: 'h2',
                className: classes.compare,
              }}
            />
            <CardContent>
              {isResAccount ? (
                <DataBrowserWidget
                  entityId={
                    pgeEnergyTrackerData?.energyTrackerInfo?.identifiers?.[0]
                  }
                />
              ) : (
                <DataBrowserWidget
                  entityId={
                    pgeEnergyTrackerData?.energyTrackerInfo?.identifiers?.[0]
                  }
                  props={[
                    {
                      'opower-instance': 'widget-data-browser-non-res',
                    },
                  ]}
                />
              )}
            </CardContent>
          </Card>
        </Grid>
      )}

      <Grid item>
        <Grid container direction="row" spacing={2}>
          <Grid item xs={12} sm={12}>
            <Card>
              <CardHeader
                title={t('HOW_DO_YOU_COMPARE')}
                titleTypographyProps={{
                  variant: 'h2',
                  className: classes.compare,
                }}
              />
              <CardContent style={{ marginTop: '-1em' }}>
                {isResAccount ? (
                  <BillComparisonWidget
                    entityId={
                      pgeEnergyTrackerData?.energyTrackerInfo?.identifiers?.[0]
                    }
                  />
                ) : (
                  <BillComparisonWidgetNonRes
                    entityId={
                      pgeEnergyTrackerData?.energyTrackerInfo?.identifiers?.[0]
                    }
                    props={[
                      {
                        'opower-instance':
                          'widget-bill-compare-enhanced-non-res',
                      },
                    ]}
                  />
                )}
                <Divider variant={'fullWidth'} />
                {/* {!Boolean(error) &&
                  ((projectedUsageLoading && <CircularProgress />) || (
                    <ProjectedUsage
                      showProjectedUsage={showProjectedUsage}
                      details={projectedUsageData?.details}
                    />
                  ))} */}
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default EnergyUsage;
